// extracted by mini-css-extract-plugin
module.exports = {"icon":"InvoiceableIndicator_icon__2qy7V"};